var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('Sidebar'),_c('div',{staticClass:"main"},[_c('Navbar'),_c('Content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }